/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { DataTakerStaffDataModel } from '../../models/data-taker-staff-data-model';

export interface GetActiveStaffMembers$Params {
}

export function GetActiveStaffMembers(http: HttpClient, rootUrl: string, params?: GetActiveStaffMembers$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<DataTakerStaffDataModel>>> {
  const rb = new RequestBuilder(rootUrl, GetActiveStaffMembers.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<DataTakerStaffDataModel>>;
    })
  );
}

GetActiveStaffMembers.PATH = '/api/Staff/GetActiveStaffMembers';
